module.exports = __webpack_public_path__ + "static/media/TireServiceGroup.28383c39.svg";